const en = {
    title: "Login Form", customerNumber: "CustomerID", user: "Username", password: "Password",
    loginButton: "Continue", unlockButton: "Unlock", pinTitle: "Unlock login details",
    pin: "PIN", confirmPin: "Repeat PIN", useCredentials: "Enter login details", usePin: "Use saved PIN",
    remember: "Remember login details", working: "Please wait…",
    errorMessages: {
        customerNumber: "CustomerID must be exactly 7 digits", user: "Username is required",
        password: "Password is required", pinLength: "PIN must contain exactly 5 digits.", weakPin: "This PIN is too simple. Choose a different PIN.",
        pinMismatch: "The PINs do not match.", invalidPin: "Could not unlock login details. Try again or enter login details.",
        invalidCredentials: "Complete all login fields correctly.", storageUnavailable: "Could not remember login details. Try without remembering.",
        errorInvalidCredentials: "Authorization error. Check your login details and try again.",
    }
};
const pl = {
    title: "Dane logowania", customerNumber: "CustomerID", user: "Login", password: "Hasło",
    loginButton: "Dalej", unlockButton: "Odblokuj", pinTitle: "Odblokuj dane logowania",
    pin: "PIN", confirmPin: "Powtórz PIN", useCredentials: "Wprowadź dane logowania", usePin: "Użyj zapamiętanego PIN-u",
    remember: "Zapamiętaj dane logowania", working: "Proszę czekać…",
    errorMessages: {
        customerNumber: "CustomerID musi mieć dokładnie 7 cyfr", user: "Login jest wymagany",
        password: "Hasło jest wymagane", pinLength: "PIN musi mieć dokładnie 5 cyfr.", weakPin: "Ten PIN jest zbyt prosty. Wybierz inny PIN.",
        pinMismatch: "Podane PIN-y są różne.", invalidPin: "Nie udało się odblokować danych. Spróbuj ponownie lub podaj dane logowania.",
        invalidCredentials: "Uzupełnij poprawnie wszystkie dane logowania.", storageUnavailable: "Nie udało się zapamiętać danych. Spróbuj bez zapamiętywania.",
        errorInvalidCredentials: "Błąd autoryzacji. Sprawdź dane logowania i spróbuj ponownie.",
    }
};

const de = {
    title: "Anmeldung", customerNumber: "DAT-Kundennummer", user: "Benutzer", password: "Passwort",
    loginButton: "Anmelden", unlockButton: "Entsperren", pinTitle: "Zugangsdaten entsperren",
    pin: "PIN", confirmPin: "PIN wiederholen", useCredentials: "Zugangsdaten eingeben", usePin: "Gespeicherten PIN verwenden",
    remember: "Zugangsdaten speichern", working: "Bitte warten …",
    errorMessages: {
        customerNumber: "Die DAT-Kundennummer muss genau 7 Ziffern enthalten.", user: "Bitte geben Sie Ihren Benutzernamen ein.",
        password: "Bitte geben Sie Ihr Passwort ein.", pinLength: "Der PIN muss genau 5 Ziffern enthalten.", weakPin: "Dieser PIN ist zu einfach. Wählen Sie einen anderen PIN.",
        pinMismatch: "Die eingegebenen PINs stimmen nicht überein.", invalidPin: "Die Zugangsdaten konnten nicht entsperrt werden. Versuchen Sie es erneut oder geben Sie Ihre Zugangsdaten ein.",
        invalidCredentials: "Bitte prüfen Sie die eingegebenen Zugangsdaten.", storageUnavailable: "Die Zugangsdaten konnten nicht gespeichert werden. Versuchen Sie es ohne Speicherung.",
        errorInvalidCredentials: "Die Anmeldung ist fehlgeschlagen. Bitte prüfen Sie Ihre Zugangsdaten.",
    }
};
const sk = {
    title: "Prihlásenie", customerNumber: "Číslo zákazníka DAT", user: "Používateľ", password: "Heslo",
    loginButton: "Prihlásiť sa", unlockButton: "Odomknúť", pinTitle: "Odomknúť prihlasovacie údaje",
    pin: "PIN", confirmPin: "Zopakujte PIN", useCredentials: "Zadať prihlasovacie údaje", usePin: "Použiť uložený PIN",
    remember: "Uložiť prihlasovacie údaje", working: "Čakajte, prosím…",
    errorMessages: {
        customerNumber: "Číslo zákazníka musí obsahovať presne 7 číslic.", user: "Zadajte používateľské meno.",
        password: "Zadajte heslo.", pinLength: "PIN musí obsahovať presne 5 číslic.", weakPin: "Tento PIN je príliš jednoduchý. Zvoľte iný PIN.",
        pinMismatch: "Zadané PIN-y sa nezhodujú.", invalidPin: "Prihlasovacie údaje sa nepodarilo odomknúť. Skúste to znova alebo zadajte prihlasovacie údaje.",
        invalidCredentials: "Skontrolujte zadané prihlasovacie údaje.", storageUnavailable: "Prihlasovacie údaje sa nepodarilo uložiť. Skúste to bez uloženia.",
        errorInvalidCredentials: "Prihlásenie zlyhalo. Skontrolujte prihlasovacie údaje.",
    }
};
const cs = {
    title: "Přihlášení", customerNumber: "Číslo zákazníka DAT", user: "Uživatel", password: "Heslo",
    loginButton: "Přihlásit se", unlockButton: "Odemknout", pinTitle: "Odemknout přihlašovací údaje",
    pin: "PIN", confirmPin: "Zopakujte PIN", useCredentials: "Zadat přihlašovací údaje", usePin: "Použít uložený PIN",
    remember: "Uložit přihlašovací údaje", working: "Čekejte, prosím…",
    errorMessages: {
        customerNumber: "Číslo zákazníka musí obsahovat přesně 7 číslic.", user: "Zadejte uživatelské jméno.",
        password: "Zadejte heslo.", pinLength: "PIN musí obsahovat přesně 5 číslic.", weakPin: "Tento PIN je příliš jednoduchý. Zvolte jiný PIN.",
        pinMismatch: "Zadané PINy se neshodují.", invalidPin: "Přihlašovací údaje se nepodařilo odemknout. Zkuste to znovu nebo zadejte přihlašovací údaje.",
        invalidCredentials: "Zkontrolujte zadané přihlašovací údaje.", storageUnavailable: "Přihlašovací údaje se nepodařilo uložit. Zkuste to bez uložení.",
        errorInvalidCredentials: "Přihlášení selhalo. Zkontrolujte přihlašovací údaje.",
    }
};

export default { pl, de, en, sk, cs };
